import React from "react";
import { FormControl, InputGroup } from "react-bootstrap";

import Slider from "src/components/slider";
import Button from "src/components/button";

import styles from "./styles.module.scss"

interface RssSliderProps {
  show: boolean;
  onClose: () => void;
  onSubmit?: (rssUrl: string) => void;
  item?: any;
  isPending?: boolean;
  error?: boolean;
}

const RssSlider: React.FC<RssSliderProps> = ({ show, onClose, onSubmit, item, isPending, error }) => {

  const [rssUrl, setRssUrl] = React.useState(item?.rssUrl || "");
  const [localError, setLocalError] = React.useState<string | null>(null);

  const handleClose = () => {
    setRssUrl(item?.rssUrl || "");
    setLocalError(null);
    onClose();
  }

  React.useEffect(() => {
    if (error) {
      setLocalError("URL should point to XML file");
    }
  }, [error]);

  React.useEffect(() => {
    if (show) {
      setRssUrl(item?.rssUrl || "");
      setLocalError(null);
    }
  }, [item, show]);

  return (
    <Slider.Dialog
      width="380"
      show={show}
      onClose={onClose}
      className={styles.container}
    >
      <Slider.Header title="generate link" />
      <Slider.Body>
        <div className={styles.body}>
          <div className={styles.description}>
            <p className={styles.title}>
              Rss Feed URL
            </p>
            <div className={styles.subtext}>
            Connect your feed by pasting the URL below.
            </div>
          </div>

          <InputGroup className={styles.inputGroup}>
            <FormControl
              value={rssUrl}
              className={styles.customInput}
              onChange={(e) => {
                setRssUrl(e.target.value);
                setLocalError(null);
              }}
              placeholder="Enter your RSS Feed URL..."
            />
          </InputGroup>
          {localError && (
            <div className={styles.errorText}>
              <i className="paperflite-danger" /> {localError}
            </div>
          )}
        </div>
      </Slider.Body>
      <Slider.Actions>
        <Button
          icon="paperflite-tick"
          variant="primary"
          onClick={() => onSubmit?.(rssUrl)}
          text={isPending ? "Saving..." : "Save"}
          disabled={isPending}
        />
        <Button onClick={handleClose} text="Cancel" />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default RssSlider;